// Datenschutzfreundliches Website-Tracking (cookielos-fähig).
// - Ohne Einwilligung: nur anonyme Tages-Sitzungen (Server hasht IP+UA+Datum,
//   nicht umkehrbar, kein Cross-Day-Tracking).
// - Mit Einwilligung ("alle"): zusätzlich eine zufällige anonyme Besucher-ID
//   (localStorage), damit "neu vs. wiederkehrend" funktioniert.
// Es werden keine Namen, Inhalte oder personenbezogenen Profile erfasst.

const CONSENT_KEY = "jh-cookie-consent";
const VID_KEY = "jh-vid";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getConsent() {
  return localStorage.getItem(CONSENT_KEY); // "all" | "necessary" | null
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === "all") {
    if (!localStorage.getItem(VID_KEY)) localStorage.setItem(VID_KEY, crypto.randomUUID());
  } else {
    localStorage.removeItem(VID_KEY);
  }
}

function getVid() {
  if (getConsent() !== "all") return null;
  let vid = localStorage.getItem(VID_KEY);
  if (!vid) {
    vid = crypto.randomUUID();
    localStorage.setItem(VID_KEY, vid);
  }
  return vid;
}

function send(payload) {
  try {
    const body = JSON.stringify({
      ...payload,
      vid: getVid(),
      w: window.innerWidth,
      ref: document.referrer || null,
    });
    fetch(`${BASE}/analytics/collect`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* Tracking darf nie die Seite stören */
  }
}

export function trackPageview(path) {
  send({ t: "pageview", path: path || window.location.pathname });
}

export function trackEvent(name) {
  send({ t: "event", name, path: window.location.pathname });
}

const seenSections = new Set();
export function trackSection(name) {
  if (seenSections.has(name)) return;
  seenSections.add(name);
  send({ t: "section", name, path: window.location.pathname });
}

// Beobachtet Bereiche und meldet einmalig, wenn sie sichtbar wurden.
export function observeSections(map) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const label = map[entry.target.dataset.trackKey];
          if (label) trackSection(label);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.35 }
  );
  Object.keys(map).forEach((key) => {
    document
      .querySelectorAll(`[data-testid="${key}"]`)
      .forEach((el) => {
        el.dataset.trackKey = key;
        observer.observe(el);
      });
  });
  return observer;
}
